import { Input, Modal, message } from 'antd';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { betaAccessStore } from '@/stores';

interface GrantBetaDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function GrantBetaDialog({ open, onOpenChange }: GrantBetaDialogProps) {
  const [uid, setUid] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    const trimmedUid = uid.trim();
    if (!trimmedUid) {
      message.error('请输入用户 UID');
      return;
    }

    setLoading(true);
    try {
      await betaAccessStore.grantBetaAccess({ user_id: trimmedUid });
      message.success('已成功为该用户添加内测资格');
      onOpenChange(false);
      setUid('');
    } catch (error) {
      console.error('添加内测资格失败:', error);
      message.error('添加内测资格失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={() => onOpenChange(false)}
      title="给用户加内测资格"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            取消
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={loading}
            style={{
              background: 'linear-gradient(135deg, #ff5c5c 0%, #ff7070 100%)',
              color: '#ffffff',
              boxShadow:
                '0 4px 12px rgba(255, 92, 92, 0.4), 0 0 0 1px rgba(255, 92, 92, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
              cursor: loading ? 'not-allowed' : 'pointer',
            }}
            className="hover:opacity-90 hover:shadow-lg transition-all font-semibold"
          >
            {loading ? '处理中...' : '确认'}
          </Button>
        </div>
      }
      centered
      styles={{
        container: {
          padding: '24px',
          borderRadius: '8px',
          backgroundColor: 'var(--card)',
          border: '1px solid var(--border)',
        },
      }}
    >
      <p className="text-sm text-muted-foreground mb-4">
        输入用户 UID，系统将直接为该用户开通内测资格，不再创建邀请码。若该用户此前已被撤销，也会在这里重新加回去。
      </p>
      <div className="space-y-4 py-2">
        <div className="space-y-2">
          <Label htmlFor="uid">用户 UID</Label>
          <Input
            id="uid"
            value={uid}
            onChange={(e) => setUid(e.target.value)}
            placeholder="请输入用户 UID"
            className="w-full"
          />
        </div>
      </div>
    </Modal>
  );
}
